const CustomerActionTypes = {
  SET_CURRENT_INFORMATION_TYPE: 'SET_CURRENT_INFORMATION_TYPE',
  SET_CURRENT_CUSTOMER_INFO: 'SET_CURRENT_CUSTOMER_INFO',
  SET_HAS_CD_DEFAULT_INFO: 'SET_HAS_CD_DEFAULT_INFO'
};

export default CustomerActionTypes;
